import React from 'react';
import { Button } from './ui/Button';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Request a Quote',
    description: "Tell us about your property and cleaning needs. We'll provide a fast, no-obligation estimate."
  }, {
    number: '2',
    title: 'We Schedule & Fly',
    description: 'Our FAA-certified pilots arrive on-site with our drone fleet, ready to clean — no scaffolding, no lifts.'
  }, {
    number: '3',
    title: 'Enjoy the Results',
    description: 'Sit back while we deliver sparkling, spot-free results in a fraction of the time.'
  }];
  return <section className="bg-white py-20 lg:py-28 font-heading" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B3A5C] mb-4 uppercase tracking-tight" data-id="element-101">
            How It Works
          </h2>
          <p className="text-lg text-[#1E1E1E]/80" data-id="element-102">
            From estimate to execution — getting started is easy.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto mb-16" data-id="element-103">
          {/* Connecting Line (Desktop Only) */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-[#F5F7FA] -z-10" data-id="element-104" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-105">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center relative" data-id="element-106">
                <div className="w-24 h-24 rounded-full bg-[#1B3A5C] text-white flex items-center justify-center text-3xl font-bold mb-6 shadow-lg relative z-10 border-4 border-white" data-id="element-107">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-[#1B3A5C] mb-3" data-id="element-108">
                  {step.title}
                </h3>
                <p className="text-[#1E1E1E] leading-relaxed" data-id="element-109">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-110">
          <Button className="bg-[#F5A623] hover:bg-[#E09520] text-[#1B3A5C] font-bold text-lg h-14 px-10 rounded-lg shadow-md hover:shadow-lg transition-all" data-id="element-111">
            Get Your Free Estimate
          </Button>
        </div>
      </div>
    </section>;
}